import {css} from 'emotion'
import {Colors} from './..'
import { Easings } from '../core';

export const PanelPDFStyle = (active) => css({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '300px',
  padding:'1rem',
  transform: `translateY(-100%) scaleY(${active ? 1 : 0})`,
  background: 'white',
  // display: active ? 'block' : 'none',
  transformOrigin: 'center bottom',
  transition: `transform 400ms ${Easings.customEase}`,
  border: `1px solid ${Colors.lightGrey}`,
  // borderRight: 0,
  'a': {
    color: Colors.mediumGrey,
    display: 'block',
    margin: '1rem 0px',
    position: 'relative',
    textAlign: 'right',
    display: 'flex',
    opacity: active ? 1 : 0,
    transition: `opacity 200ms ease ${ active ? 400 : 0}ms, color 200ms ease`,
    'span': {
      width: 'calc(100% - 50px)',
      // flexWidth: 'calc(100% - 50px)',
    },
    'svg': {
      fill: Colors.grey,
      verticalAlign: 'baseline',
      margin: '0 1rem',
    },
    '&:hover': {
      color: 'black',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/panelPDF.js